import React, { useEffect, useState } from "react";
import "./ChangePassword.css";
import { getChangePasswords } from "../../../config/LiveApi";
import Pagination from "../pagination";
import { toast } from "react-toastify";

const ChangePasswordPage = () => {
  const [statusData, setStatusData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const fetchChangePasswordData = async (currentPage,searchTerm) => {
    try {
      setLoading(true);
      const response = await getChangePasswords(currentPage, searchTerm);
      setStatusData(response);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Unable to fetch status.");
    }
  };
  useEffect(() => {
    if (searchTerm !== "") {
      const delayDebounce = setTimeout(() => {
        fetchChangePasswordData(1, searchTerm);
      }, 2000);

      return () => clearTimeout(delayDebounce);
    }
  }, [searchTerm]);

  useEffect(() => {
    if (searchTerm === "") {
      fetchChangePasswordData(currentPage, "");
    }
  }, [currentPage, searchTerm]);

  return (
    <div className="change-password-table-container">
      <div className="change-password-heading">
        <h2 className="change-password-table-title">Change Password</h2>
        <input
          className="password-input-field-container"
          type="text"
          placeholder="Email"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>
      <table className="password-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Updated at</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="4">Loading...</td>
            </tr>
          ) : statusData?.length > 0 ? (
            statusData.map((item, index) => {
              return (
                <tr key={index}>
                  <td>{item?.alias ?? item?.name ?? "-"}</td>
                  <td>{item?.email ? item?.email : "-"}</td>
                  <td>
                    {new Date(item?.updatedAt).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                      hour12: false,
                    })}
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan="4">No data found.</td>
            </tr>
          )}
        </tbody>
      </table>
      <Pagination currentPage={currentPage} setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default ChangePasswordPage;
